module.exports = __webpack_public_path__ + "static/media/1006096.c17c3125.png";